import React from "react";
import { BrandSection, BrandFeature } from "~/common/Store/models/Brand";
import ExpandedBrandFeatureGroups from "./ExpandedBrandFeatureGroups";
import ExpandedShopTheLookGroup from "./ExpandedShopTheLookGroup";
import ExpandedFeatureGroupCarousel from "~/Brands/ExpandedFeatureGroupCarousel/index";

interface Props {
  sections: BrandSection[];
  hideChildItemLinks?: boolean;
}

const renderFeatureGroup = (
  type: string,
  features: BrandFeature[],
  index: number,
  hideChildItemLinks?: boolean,
) => {
  switch (type) {
    case "Row":
      return (
        <ExpandedBrandFeatureGroups
          features={features}
          key={`${type}${index}`}
          hideChildItemLinks={hideChildItemLinks}
        />
      );
    case "EnhancedCarousel":
      return (
        <ExpandedFeatureGroupCarousel
          featureGroup={features[0]!.carouselFeatureGroup}
          key={`${type}${index}`}
        />
      );
    case "ShopTheLook":
      return (
        <ExpandedShopTheLookGroup
          featureGroup={features[0]!.shopTheLookGroup}
          key={`${type}${index}`}
        />
      );
    default:
      return null;
  }
};

const ExpandedBrandSections = ({ sections, hideChildItemLinks }: Props) => (
  <>
    {sections.map(
      (section, index) =>
        section.features.length > 0 &&
        renderFeatureGroup(
          section.type,
          section.features,
          index,
          hideChildItemLinks,
        ),
    )}
  </>
);

export default ExpandedBrandSections;
